<template>
  <div class="comment" v-if="comment" @copy.prevent="copyComment">
    <div class="comment__header">
      <Avatar
        class="comment__header-avatar"
        :fullName="comment.author.fullName"
        :url="comment.author.avatar"
        :size="40"
      />

      <div class="message">
        <div class="message__info">
          {{
            `${comment.author.fullName || ''} (${
              comment.author.userName || ''
            }) | ${comment.updated_date} ${
              +comment.to_recruits ? '| Виден только рекрутерам' : ''
            }`
          }}
        </div>
        <div class="message__text">
          <EditorDataParser :data="text || ''" />
          <ActionsMenu
            class="message__text-actionmenu"
            v-if="
              userId == comment.author_id && !Number(comment.system_comment)
            "
            :actions="[
              { id: 'edit', name: 'Редактировать' },
              { id: 'delete', name: 'Удалить' }
            ]"
            type="Pen"
            buttonSize="small"
            @handleCommand="handleCommand"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from '@/utils/mixins';
import Avatar from 'Elements/Avatar/Avatar';
import ActionsMenu from 'Elements/Menu/ActionsMenu';
import EditorDataParser from 'Elements/Editor/EditorDataParser';
import Clipboard from 'v-clipboard';
import Vue from 'vue';
Vue.use(Clipboard);
export default {
  mixins: [mixin],
  name: 'comment',
  props: {
    comment: {
      type: Object,
      default: () => ({})
    },
    userId: { type: String, default: '1' }
  },
  computed: {
    text() {
      if (this.comment.content.includes('&lt;p&gt;')) {
        const openTagIndex = this.comment.content.indexOf('&lt;p&gt;');
        const closeTagIndex = this.comment.content.lastIndexOf('&lt;/p&gt;');

        return (
          this.comment.content.substring(0, openTagIndex) +
          this.comment.content.substring(openTagIndex + 9, closeTagIndex) +
          this.comment.content.substring(
            closeTagIndex + 10,
            this.comment.content.length
          )
        );
      } else {
        return this.comment.content;
      }
    },
    userAvatarLink() {
      return `/index.php?entryPoint=download&id=${this.comment.author_id}_photo&type=Users`;
    },
    userLink() {
      return `/index.php?module=Users&action=DetailView&record=${this.comment.author_id}`;
    }
  },
  methods: {
    replaceMentions(selectedText, htmlText) {
      const mentionRegex =
        /<span class="mention" data-mention="([^"]+)" data-user-id="[^"]+">([^<]+)<\/span>/g;

      const mentionsMap = {};
      let match;

      while ((match = mentionRegex.exec(htmlText)) !== null) {
        const [fullMatch, mentionText] = match;
        mentionsMap[mentionText] = fullMatch;
      }

      Object.keys(mentionsMap).forEach(mentionText => {
        const escapedMentionText = mentionText.replace(
          /[.*+?^${}()|[\]]/g,
          '$&'
        );
        const mentionPattern = new RegExp(`${escapedMentionText}`, 'g');
        selectedText = selectedText.replace(
          mentionPattern,
          mentionsMap[mentionText]
        );
      });

      return selectedText;
    },
    copyComment() {
      const selectedText = window.getSelection().toString();
      let formatText = '';
      if (selectedText.includes('@')) {
        formatText = this.replaceMentions(selectedText, this.text);
      } else {
        formatText = selectedText;
      }
      this.$clipboard(formatText);
    },
    handleCommand(command) {
      this.$emit(
        command.id === 'edit' ? 'editComment' : 'deleteComment',
        this.comment
      );
    }
  },
  components: {
    Avatar,
    ActionsMenu,
    EditorDataParser
  }
};
</script>
<style lang="scss" scoped>
.comment {
  display: flex;
  width: 100%;

  &__header {
    display: flex;
    flex-direction: row;
    width: 100%;

    &-avatar {
      display: flex;
      margin-right: 16px;
    }

    .message {
      width: 100%;
      max-width: 100%;
      background: $grey8;
      border-radius: 4px;
      padding: 8px;
      width: 100%;
      color: $grey80;
      text-align: left;

      &__text {
        width: 100%;
        font-size: 15px;
        line-height: 24px;
        position: relative;

        &-actionmenu {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }

      &__info {
        display: flex;
        flex-direction: row;
        color: $grey64;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        overflow: hidden;
        max-width: 100%;
        white-space: nowrap;
      }

      & ::v-deep p {
        margin: 0;
      }

      & ::v-deep a {
        margin: 0;
        display: flex;
        flex: none;
        word-break: break-all;
      }

      & ::v-deep b {
        margin: 0;
      }

      & ::v-deep pre {
        margin: 0;
        font-family: 'Roboto', sans-serif;
      }

      & ::v-deep .info__tag {
        display: inline-block;
        color: $white;
        font-size: 14px;
        padding: 0 8px;
        margin: 0 8px 0 0;
        width: fit-content;
        border-radius: 4px;
        background: $grey64;
      }
    }
  }
}
</style>
